import { ITableNumberColumnFilter } from "models/TableNumberColumnFilter";
import { BaseService } from "./base.service";
import {
	BidQueryDelegateModel,
	BidQueryDetailModel,
	BidQueryModel,
} from "models/VendorPortal/queryDetail";
import { IBidNumber } from "models/Bid/BidNumberModel";
import { TableFilterModel } from "models/TableFilterModel";
import {
	IQueryBidSummaryGridDetail,
	IVendorBidQueryGridDetail,
	IVendorBidQueryNumber,
} from "models/VendorPortal/queryBidSummaryGridDetail";

class VendorBidQueryServiceInternal extends BaseService {
	getVendorBidQueryById = async (
		vendorBidQueryId: number
	): Promise<BidQueryDetailModel> =>
		this.callApi<BidQueryDetailModel>(
			`VendorBidQuery/Get/${vendorBidQueryId}`,
			"GET"
		);

	saveVendorBidQuery = async (model: BidQueryModel): Promise<number> =>
		this.callApi<number>(`VendorBidQuery/Save`, "POST", undefined, model);

	submitVendorBidQuery = async (vendorBidQueryId: number): Promise<number> =>
		this.callApi<number>(
			`VendorBidQuery/Submit/${vendorBidQueryId}`,
			"POST",
			undefined,
			undefined
		);

	deleteVendorBidQuery = async (vendorBidQueryId: number): Promise<boolean> =>
		this.callApi<boolean>(
			`VendorBidQuery/Delete/${vendorBidQueryId}`,
			"DELETE",
			undefined,
			undefined
		);

	respondVendorBidQuery = async (model: FormData): Promise<number> =>
		this.callApi<number>(
			`VendorBidQuery/Respond`,
			"POST",
			undefined,
			model,
			false,
			true
		);

	getVendorBidQueryDetail = async (
		vendorBidQueryId: string
	): Promise<BidQueryDetailModel> =>
		this.callApi<BidQueryDetailModel>(
			`VendorBidQuery/GetVendorBidQueryDetail`,
			"POST",
			undefined,
			{
				Key: vendorBidQueryId.toString(),
			}
		);

	getBidQueryNumberList = async (
		model: TableFilterModel
	): Promise<IBidNumber[]> =>
		this.callApi<IBidNumber[]>(
			`VendorBidQuery/GetBidQueryNumberList`,
			"POST",
			undefined,
			model
		);

	getBidQueryList = async (
		model: TableFilterModel
	): Promise<IQueryBidSummaryGridDetail[]> =>
		this.callApi<IQueryBidSummaryGridDetail[]>(
			`VendorBidQuery/GetBidQueryList`,
			"POST",
			undefined,
			model
		);

	getVendorBidQueryList = async (
		bidId: number,
		model: TableFilterModel
	): Promise<IVendorBidQueryGridDetail[]> =>
		this.callApi<IVendorBidQueryGridDetail[]>(
			`VendorBidQuery/GetVendorBidQueryList/${bidId}`,
			"POST",
			undefined,
			model
		);

	getVendorBidQueryNumberList = async (
		bidId: number,
		model: ITableNumberColumnFilter
	): Promise<IVendorBidQueryNumber[]> =>
		this.callApi<IVendorBidQueryNumber[]>(
			`VendorBidQuery/GetVendorBidQueryNumberList/${bidId}`,
			"POST",
			undefined,
			model
		);

	delegateVendorBidQuery = async (
		model: BidQueryDelegateModel
	): Promise<number> =>
		this.callApi<number>(
			`VendorBidQuery/DelegateVendorBidQuery`,
			"POST",
			undefined,
			model
		);

	respondAll = async (vendorBidQueryIds: number[]): Promise<boolean> =>
		this.callApi<boolean>(
			`VendorBidQuery/RespondAll`,
			"POST",
			undefined,
			vendorBidQueryIds
		);
}

export const VendorBidQueryService = new VendorBidQueryServiceInternal();
